import { createStore } from 'vuex'
import shipmentRequest from './shipmentRequest'
import consolidation from './consolidation'

export default createStore({
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    shipmentRequest,
    consolidation
  }
})
